import { environment } from 'src/environments/environment';

/**
 * Construye la URL completa de un archivo (logo, avatar, cv) de forma segura.
 * Evita generar URLs inválidas como `/archivos/null` cuando el valor viene null
 * desde el backend (lo que provocaba 500 en el API).
 */
export function construirUrlArchivo(path: string | null | undefined, defecto: string): string {
  if (path == null || path === '' || path === defecto) {
    return defecto;
  }
  if (path.startsWith('http')) {
    return path;
  }
  return environment.baseArchivos + path;
}
